// extracted by mini-css-extract-plugin
module.exports = {"root":"IconPersonalInfo_root__XMXbM"};